// store/Assignments.js

const state = {};

const mutations = {};

const actions = {};

const getters = {
  canCreateRemoveParcelAssignment: (state, getters, rootState, rootGetters) => {
    return rootGetters['auth/hasRole']([
      'ROLE_ADMIN',
      'ROLE_REMOVE_PARCELS_FROM_CONS',
    ]);
  },
};

export default {
  namespaced: true,
  state,
  mutations,
  actions,
  getters,
};
